export default "__VITE_ASSET__CgWaFW5R__"